import { render } from "./FieldRulesValidation.vue?vue&type=template&id=37387b74&scoped=true"
import script from "./FieldRulesValidation.vue?vue&type=script&lang=js"
export * from "./FieldRulesValidation.vue?vue&type=script&lang=js"

import "./FieldRulesValidation.vue?vue&type=style&index=0&id=37387b74&lang=scss&scoped=true"

import exportComponent from "/app/tmp/blackhall/V3/v2026.9.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37387b74"]])

export default __exports__